import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Honest failure surface for file store calls. The facade rejects
 * unauthenticated calls (401) and the dev proxy answers 502 when the service
 * is down — both land here with the real message rather than a fake empty
 * state.
 */
export const FilestoreErrorBanner = ({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) => (
  <div
    role='alert'
    className='flex items-start justify-between gap-4 rounded-lg border border-destructive/30 bg-destructive/10 px-4 py-3'
  >
    <div className='flex items-start gap-3'>
      <AlertTriangle className='mt-0.5 size-4 shrink-0 text-destructive' />
      <div className='text-sm'>
        <p className='font-medium text-destructive'>
          Couldn&apos;t reach the file store
        </p>
        <p className='mt-0.5 text-muted-foreground'>{message}</p>
      </div>
    </div>
    {onRetry && (
      <Button variant='outline' size='sm' onClick={onRetry}>
        Retry
      </Button>
    )}
  </div>
);
